export const ADD_NOTE = 'ADD_NOTE'
export const ADD_NOTE_ERR = 'ADD_NOTE_ERR'

export const GET_NOTES_BY_USER = 'GET_NOTES_BY_USER'
export const GET_NOTES_BY_USER_ERR = 'GET_NOTES_BY_USER_ERR'

export const CLEAR_NOTES = 'CLEAR_NOTES'